module.exports = __webpack_public_path__ + "media/images/athletes/3572-14bd44f39a9d94cbb6b69caf8f08a785.png";